module.exports = __webpack_public_path__ + "static/img/3-1.39afec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-1.jpg
// module id = hwHC
// module chunks = 1